import React from 'react'
import { Steps } from 'antd'
import StepsIcon from 'components/icons/StepsIcon'
import StepsCompleted from 'components/icons/StepsCompleted'
import EmptyCircle from 'components/icons/EmptyCircle'
import styled from 'styled-components'
import { COLORS } from 'theme'

const { Step } = Steps

const Div = styled.div`
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background-color: ${COLORS.GREEN_S_100};
  }
`
const Title = styled.h2`
  font-weight: 500;
  font-size: 16px;
  font-style: normal;
  line-height: 21px;
  color: ${props => props?.textcolor};
  white-space: nowrap;
`
const StyledStep = styled(Step)`
  .ant-steps-item-title {
    width: 57%;
    border-bottom: 1px solid #e6e7ea;
  }
`

const AntdSteps = ({
  steps,
  direction = 'vertical',
  size = 'small',
  current = '1',
  ...props
}) => {
  return (
    <Div>
      <Steps direction={direction} size={size} current={current} {...props}>
        {steps?.map((step, index) => (
          <StyledStep
            key={index+"stepIcon"}
            icon={
              current > step?.activeKey ? (
                <StepsCompleted />
              ) : step?.activeKey == current ? (
                <StepsIcon />
              ) : (
                <EmptyCircle />
              )
            }
            title={
              <Title
                textcolor={step?.activeKey == current ? '#4D566E' : '#999FAC;'}
              >
                {step?.title}
              </Title>
            }
          />
        ))}
      </Steps>
    </Div>
  )
}

export default AntdSteps
